import classes from "./simset-table.module.scss";
import Flex from "@/components-library/layout/flex";
import Label from "@/components-library/widgets/label";
import classNames from "classnames";
import Grid from "@/components-library/layout/grid";
function SimsetTable() {
  const columns = "1fr 1fr 1fr 1fr";
  const table = [
    {
      columns: ["Tipologia linea", "Spese", "Durata finanziamento", "Importi"],
    },
    {
      columns: [
        "Fiere ed eventi",
        "Ammissibili le spese per partecipare alla fiera (spazio espositivo, montaggio, trasporto, ecc.). Ammissibili fino a 3 fiere",
        "4 anni di cui 2 di pre-ammortamento",
        "Fino a 500.000 € o comunque max 20% dei ricavi dell’ultimo anno e dei ricavi medi degli ultimi due bilanci per domande sopra i 150.000 €",
      ],
    },
    {
      columns: [
        "E-commerce",
        "Costi di creazione o miglioramento di una propria piattaforma. Costi per accesso a marketplace. Costi per spese promozionali e marketing",
        "4 anni di cui 2 di pre-ammortamento",
        "fino a 500 mila euro e comunque non superiore al 20% dei ricavi medi risultanti dagli ultimi due bilanci depositati dall’impresa",
      ],
    },
    {
      columns: [
        "Transizione digitale o ecologica",
        "Investimenti in digitalizzazione o in ottica ecologica, investimenti per rafforzare la propria solidità patrimoniale, consulenze",
        "6 anni, di cui 2 di pre-ammortamento",
        "Fino a 500 mila euro per le microimprese;\nFino a 2,5 milioni di euro per le PMI e PMI innovative;\nFino a 5 milioni di euro per le altre imprese.\nComunque, non superiore al 35% dei ricavi medi degli ultimi 2 bilanci",
      ],
    },
    {
      columns: [
        "Inserimento mercati esteri",
        "Costi per un’apertura di una propria struttura in un paese estero o potenziamento struttura già esistente.",
        "6 anni, di cui 2 di pre-ammortamento",
        "Fino a 500 mila euro per le microimprese;\nFino a 2,5 milioni di euro per le PMI e PMI innovative;\nFino a 5 milioni di euro per le altre imprese.\nComunque, non superiore al 35% dei ricavi medi degli ultimi 2 bilanci",
      ],
    },
    {
      columns: [
        "Temporary manager",
        "Costi per consulenze dei Temporary manager utilizzati per progetti di internazionalizzazione, innovazione tecnologica, digitale o ecologica",
        "4 anni, di cui 2 di pre-ammortamento",
        "Fino a 500 mila euro.\nComunque, non superiore al 20% dei ricavi medi degli ultimi 2 bilanci",
      ],
    },
    {
      columns: [
        "Certificazioni e consulenze",
        "Costi per consulenze specialistiche e studi di fattibilità per l’internazionalizzazione o per l’innovazione digitale",
        "4 anni, di cui 2 di pre-ammortamento",
        "Fino a 500 mila euro.\nComunque, non superiore al 20% dei ricavi medi degli ultimi 2 bilanci",
      ],
    },
  ];
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classes.table}
    >
      {table.map((row, indexRow) => (
        <Grid
          key={`indexRowGridSimest_${indexRow}`}
          columns={columns}
          columnGap={"2px"}
          className={classNames({
            [classes.header]: indexRow === 0,
            [classes.row]: indexRow !== 0,
          })}
        >
          {row.columns.map((column, index) => (
            <Label
              key={`indexRowColumnSimest_${index}`}
              tag="p"
              size="md"
              color={indexRow === 0 ? "default" : "secondary"}
              align="start"
              weight="bold"
              className={classNames(classes.item, {
                [classes.firstColumn]: index === 0,
                [classes.secondColumn]: index === 1,
                [classes.thirdColumn]: index === 2,
                [classes.fourthColumn]: index === 3,
              })}
            >
              {column}
            </Label>
          ))}
        </Grid>
      ))}
    </Flex>
  );
}

export default SimsetTable;
